import React from "react";
import { css } from "styled-components";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

const banner = css`
  z-index: 100;
  box-sizing: border-box;
  position: relative;
  margin: 0;
  width: 100%;
  max-width: 1440px;
  text-align: center;
  background-color: ${({ theme }) => theme.palette.terracotta80};
  display: block;
  padding: 10px;
  text-decoration: none;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.palette.terracotta60};
  }
`;

export const CovidBanner = () => (
  <Link to="/blog/posts/nested-coronavirus-updates" css={banner}>
    Learn how we're keeping our customers and team safe during the coronavirus
    outbreak
    <FontAwesomeIcon
      icon={faCaretRight}
      css="font-size: 16px; padding-bottom: 3px; padding-left: 4px; vertical-align: middle;"
    />
  </Link>
);
